<template>
    <div class="secondary-signature">
        <b-row style="background-color: black; position: sticky; top: 0px; height: 90px; z-index: 999;">
            <b-col cols="12" lg="12" class="d-flex justify-content-center pr-1 pl-1 mt-2 mb-2">
                <b-img :src="require('@assets/images/v3/SS Wordmark-White 1.svg')" class="logo"/>
            </b-col>
        </b-row>
        <b-container class="secondary-seller-signature">
            <section-loader
                v-if="!resourcesFetched"
                loading
            />
            <template v-if="resourcesFetched">
                <b-row v-if="activeStep === step.PRIMARY_NOT_SIGNED">
                    <b-col cols="12" lg="12">
                        <primary-needs-signature
                            :disclosureAppResource="disclosureAppResource"
                            :orderAppResource="orderAppResource"
                            :primarySeller="primarySellerAppResource"
                            @refresh="refreshData"
                        />
                    </b-col>
                </b-row>
                <b-row v-if="activeStep === step.FACTS">
                    <b-col
                        cols="12"
                        lg="12"
                    >
                        <h1 class="text-center mb-5">Understanding your risk</h1>

                        <risk-facts
                            :order-app-resource="orderAppResource"
                            @submit="handleRiskFactsSubmit"
                        />
                    </b-col>
                </b-row>
                <b-row v-if="activeStep === step.FORMS">
                    <b-col
                        cols="12"
                        lg="12"
                    >
                        <view-forms
                            :fromEmail="fromEmail"
                            :order="orderAppResource"
                            :seller="sellerAppResource"
                            :disclosure="disclosureAppResource"
                            @submit="handleViewFormsSubmit"
                        />
                    </b-col>
                </b-row>
                <b-row v-else-if="activeStep === step.UPSELL">
                    <b-col
                        cols="12"
                        lg="12"
                    >
                        <h1 class="text-center mb-5">Understanding your risk</h1>

                        <hslp-upsell
                            :order-app-resource="orderAppResource"
                            :seller-app-resource="sellerAppResource"
                            is-public
                            @addProtection="handleAddProtection"
                            @noProtection="clickNoProtection"
                        />
                    </b-col>
                </b-row>
                <b-row v-else-if="activeStep === step.SIGN">
                    <sign-documents
                        :seller="sellerAppResource"
                        :disclosure="disclosureAppResource"
                        :order="orderAppResource"
                        @fetchData="fetchData"
                        @sign-documents="signDocuments"
                    />
                </b-row>
                <b-row v-else-if="activeStep === step.SUCCESS">
                    <b-col cols="12">
                        <div class="text-center m-5">
                            <i class="fas fa-check-circle text-success font-size-px-99"></i>
                        </div>
                        <h2 class="text-center m-5">
                            Thank you for signing the documents!
                        </h2>
                    </b-col>
                </b-row>
            </template>
            <maintenance-mode/>
        </b-container>        
    </div>
</template>

<script>
import './SecondarySellerSignature.scss';
import FormErrorsMixin from "@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin";
import ShowNotificationMixin from "@sellers-shield-home-protection/ss-ui-kit/src/mixins/ShowNotificationMixin";
import DisclosureAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/DisclosureAppResource";
import SellerAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/SellerAppResource";
import {cloneDeep, get} from "lodash";
import {runAsPublic} from "@helpers/api-helper";
import SectionLoader from "@components/loaders/SectionLoader/SectionLoader";
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
import {notProtected, propertyState} from "@helpers/order";
import RiskFacts from "@components/other/RiskFacts/RiskFacts";
import HslpUpsell from "@components/other/HslpUpsell/HslpUpsell";
import {pageId} from "@helpers/fromPage";
import SignDocuments from "./SignDocuments/SignDocuments";
import {stateHasHSLP} from '@helpers/state';
import ViewForms from "./ViewForms/ViewForms";
import MaintenanceMode from "@components/other/MaintanceMode/MaintenanceMode";
import DiscountMixin from '@mixins/DiscountMixin';
import PrimaryNeedsSignature from "./PrimaryNeedsSignature/PrimaryNeedsSignature.vue";
import PusherMixin from '@mixins/PusherMixin.js';
import CommonFooter from '@components/layout/CommonFooter/CommonFooter';
const step = {
    PRIMARY_NOT_SIGNED: 'needs-signature-primary',
    FACTS: 'facts',
    FORMS: 'view-forms',
    UPSELL: 'upsell',
    SIGN: 'sign',
    SUCCESS: 'success',
};

export default {
    name: 'SecondarySellerSignature',
    components: {
        SectionLoader,
        RiskFacts,
        HslpUpsell,
        SignDocuments,
        ViewForms,
        MaintenanceMode,
        PrimaryNeedsSignature,
        CommonFooter
    },
    mixins: [
        FormErrorsMixin,
        ShowNotificationMixin,
        DiscountMixin,
        PusherMixin
    ],
    props: {
        disclosureUuid: {
            required: false
        },
        orderUuid: {
            required: false
        },
        sellerUuid: {
            required: false
        },
        fromEmail: {
            required: false,
            default: false
        }
    },
    data: () => ({
        disclosureAppResource: null,
        sellerAppResource: null,
        primarySellerAppResource: null,
        orderAppResource: null,
        step: step,
        activeStep: step.FACTS,
        loading: false,
        saving: false,
        queryParams: [],
        
    }),
    computed: {
        resourcesFetched() {
            return this.sellerAppResource?._fetched && this.disclosureAppResource?._fetched && this.orderAppResource?._fetched && !this.loading;
        },
        notProtected() {
            return notProtected(this.orderAppResource);
        },
        currentPageId() {
            return pageId(this.$route.name, false);
        },
        formsAppResources() {
            return this.orderAppResource?.forms?.toArray() || [];
        },
        hasPrimarySigned(){
            if (!this.disclosureAppResource) {
                return false;
            }

            return !!get(this.disclosureAppResource, 'meta.signatures.primarySignature', false);
        },
        hasSecondarySignature(){
                        if (!this.disclosureAppResource) {
                return false;
            }

            return !!get(this.disclosureAppResource, 'meta.signatures.secondarySignature', false);
        }
    },

    methods: {
        async fetchDisclosure(disclosureUuid, fetchOrder = false) {
            let disclosureAppResource = new DisclosureAppResource({
                uuid: disclosureUuid,
            });

            await this.catchAppResourceErrors(async () => {
                await disclosureAppResource.fetch([
                    'jotFormDisclosureSessions',
                    'jotFormDisclosureSessions.files',
                ], {includeSellerSignatures: 1});

                this.disclosureAppResource = cloneDeep(disclosureAppResource);
            }, 'loading');

            fetchOrder && Boolean(this.disclosureAppResource?.orderUuid) && await this.fetchOrder(this.disclosureAppResource.orderUuid);
        },

        async fetchSeller(sellerUuid) {
            let sellerAppResource = new SellerAppResource({
                uuid: sellerUuid,
            });
            await this.catchAppResourceErrors(async () => {
                await sellerAppResource.fetch();
                this.sellerAppResource = cloneDeep(sellerAppResource);
                this.primarySellerAppResource = cloneDeep(this.orderAppResource.sellers.toArray().find(x=>x.type === 'primary'));
            }, 'loading');
        },

        async fetchOrder(orderUuid, fetchDisclosure = false) {
            let orderAppResource = new OrderAppResource({
                uuid: orderUuid,
            });

            await this.catchAppResourceErrors(async () => {
                await orderAppResource.fetch([
                    'property',
                    'property.state',
                    'homeSaleLegalProtection',
                    'forms',
                    'forms.formAuthor',
                    'sellers'
                ]);

                this.orderAppResource = cloneDeep(orderAppResource);
            }, 'loading');

            fetchDisclosure && Boolean(this.orderAppResource?.disclosureUuid) && await this.fetchDisclosure(this.orderAppResource.disclosureUuid);
        },

        async fetchData() {
            this.loading = true;
            await runAsPublic(async () => {
                Boolean(this.disclosureAppResource._uuid)
                && this.disclosureAppResource.fetch([]);

                Boolean(this.orderAppResource._uuid)
                && this.orderAppResource.fetch([
                    'property',
                    'property.state',
                    'homeSaleLegalProtection',
                    'forms',
                    'forms.sections',
                    'forms.parentForm',
                    'forms.formAuthor',
                    'sellers'
                ]);
            });
            this.loading = false;
        },

        handleRiskFactsSubmit() {
            this.activeStep = this.step.FORMS;
        },
        handleViewFormsSubmit() {
            let state = propertyState(this.orderAppResource);
            this.activeStep = this.notProtected && stateHasHSLP(JSON.parse(state.meta)) ? this.step.UPSELL : this.step.SIGN;
        },
        async handleAddProtection() {
            this.orderAppResource.homeSaleLegalProtection.setAttribute('paymentFromId', this.currentPageId);
            await this.orderAppResource.save();

            this.activeStep = this.step.SIGN;
        },
        async refreshData(data){
            await runAsPublic(async () => {
                Boolean(this.disclosureUuid) && await this.fetchDisclosure(this.disclosureUuid, !Boolean(this.orderUuid));
                Boolean(this.orderUuid) && await this.fetchOrder(this.orderUuid, !Boolean(this.disclosureUuid));
                Boolean(this.sellerUuid) && await this.fetchSeller(this.sellerUuid);
            });

            if(this.hasPrimarySigned && !this.hasSecondarySignature){
                this.activeStep = this.step.FACTS;
            }else if(!this.hasPrimarySigned){
                this.activeStep = this.step.PRIMARY_NOT_SIGNED
            }
        },
        alreadySigned() {

            return false; //allow secondary seller to resign disclosure

            if (!this.disclosureAppResource) {
                return false;
            }

            return get(this.disclosureAppResource, 'meta.signatures.secondarySignature', false);
        },
        signDocuments() {
            this.activeStep = this.step.SUCCESS;
        },
        clickNoProtection() {
            this.activeStep = this.step.SIGN;
        }
    },

    async created() {
        const token = this.$route.query.token;

        if (token) {
            this.queryParams = token.split('_');
        }

        let disclosureUuid = this.disclosureUuid || this.queryParams[0],
            orderUuid = this.orderUuid || this.queryParams[1],
            sellerUuid = this.sellerUuid ? this.sellerUuid : this.queryParams[2];
        this.disclosureUuid = disclosureUuid;


        await runAsPublic(async () => {
            Boolean(disclosureUuid) && await this.fetchDisclosure(disclosureUuid, !Boolean(orderUuid));
            Boolean(orderUuid) && await this.fetchOrder(orderUuid, !Boolean(disclosureUuid));

            Boolean(sellerUuid) && await this.fetchSeller(sellerUuid);
        });

        if (this.fromEmail) {
            this.activeStep = this.step.FORMS;
        }

        if (!this.fromEmail && this.alreadySigned()) {
            this.activeStep = this.step.SUCCESS;
        }
        if(!this.hasPrimarySigned){
            this.activeStep = this.step.PRIMARY_NOT_SIGNED;
        }
    },
    mounted(){
        this.subscribePusherChannel(
            `disclosureUpdated.${this.disclosureUuid}`,
            {
                'updated': async (data) => {
                    console.log(data);
                    await this.refreshData(data);
                }
            }
        );
    },
    async beforeDestroy(){
        this.unsubscribePusherChannel(`disclosureUpdated.${this.disclosureUuid}`);
    }
}
</script>
